
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { HardDrive, Tag, Network, Cog, Shield } from 'lucide-react';
import NavigationItem from './NavigationItem';

interface SystemSectionContentProps {
  activeTab: string;
  onChange: (value: string) => void;
}

const SystemSectionContent = ({ 
  activeTab, 
  onChange 
}: SystemSectionContentProps) => {
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'devices'} 
              onClick={() => onChange('devices')}
              icon={<HardDrive className="h-4 w-4 mr-2" />}
              label="Devices"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Manage and configure connected meters, sensors, and controllers</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'devicegroups'} 
              onClick={() => onChange('devicegroups')}
              icon={<Tag className="h-4 w-4 mr-2" />}
              label="Device Groups"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Organize devices into logical groups and zones</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'protocols'} 
              onClick={() => onChange('protocols')}
              icon={<Network className="h-4 w-4 mr-2" />}
              label="Protocol Handlers"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure communication protocols (OPC UA, Modbus, BACnet, etc.)</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'system'} 
              onClick={() => onChange('system')}
              icon={<Cog className="h-4 w-4 mr-2" />}
              label="System"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure system-wide settings and parameters</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'security'} 
              onClick={() => onChange('security')}
              icon={<Shield className="h-4 w-4 mr-2" />}
              label="Security & Access"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure authentication and access control settings</p>
        </TooltipContent>
      </Tooltip>
    </>
  );
};

export default SystemSectionContent;
